import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';

import {
  Popup,
  Heading,
  Button,
  TabsList,
  Checkbox,
  Preloader,
  Tab,
  I18n,
  RouterLink,
} from 'components';
import { closePopup } from 'actions';
import { formatDate } from 'utils/formatString';

import { downloadReport, fetchIsEmailExist } from '../../actions';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

class ReportPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      format: 'pdf',
      step: 'initial',
      isEmailEnabled: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.actions.fetchIsEmailExist()
      .then(({ emailInfo }) => {
        this.setState({ isEmailEnabled: emailInfo.isEmailExist });
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activePopup === 'downloadReport') {
      window.dataLayer.push({
        event: 'LK_event',
        LKaction: 'Report Configuration',
      });
    }
  }

  setFormat = (format) => {
    this.setState({ format });
  }

  toggleEmailEnabled = () => {
    if (!this.props.isEmailExist) {
      return;
    }
    this.setState((prevState) => ({ isEmailEnabled: !prevState.isEmailEnabled }));
  }

  downloadReport = () => {
    const { format, isEmailEnabled } = this.state;
    this.setState({ step: 'loading' });
    this.props.actions.downloadReport(format, (this.props.isEmailExist && isEmailEnabled))
      .then(() => {
        this.setState({ step: 'success' });
      })
      .catch(() => {
        this.setState({ step: 'error' });
      });
  }

  closePopup = () => {
    this.setState({ step: 'initial' });
    this.props.actions.closePopup();
  }

  render() {
    const {
      period,
      activePopup,
      actions,
      isEmailExist,
      emailAddress,
    } = this.props;

    const {
      format,
      isEmailEnabled,
      step,
    } = this.state;

    return (
      <Popup
        opened={activePopup === 'downloadReport'}
        onClose={actions.closePopup}
      >
        {step === 'initial' && (
          <>
            <Heading className={cx('heading')} level={1}>
              <I18n
                path="detalization.reportPopup.blockTitle"
                vars={{
                  start: formatDate(period.start),
                  end: formatDate(period.end),
                }}
              />
            </Heading>
            <div className={cx('formatSelector')}>
              <div className={cx('formatSelectorTitle')}>
                <I18n path="detalization.reportPopup.inFormat" />
              </div>
              <TabsList>
                <Tab
                  active={format === 'pdf'}
                  onClick={() => this.setFormat('pdf')}
                >
                  PDF
                </Tab>
                <Tab
                  active={format === 'xls'}
                  onClick={() => this.setFormat('xls')}
                >
                  XLSX
                </Tab>
                <Tab
                  active={format === 'xls03'}
                  onClick={() => this.setFormat('xls03')}
                >
                  XLS
                </Tab>
              </TabsList>
            </div>

            <div className={cx('saveSettings')}>
              <Checkbox
                className={cx('emailCheckbox')}
                checked={isEmailExist && isEmailEnabled}
                disabled={!isEmailExist}
                handleChange={this.toggleEmailEnabled}
              >
                <I18n path="detalization.email.sendToMail" />
                {isEmailExist && emailAddress}
              </Checkbox>
              {!isEmailExist ? (
                <div className={cx('emailMessage')}>
                  <I18n path="detalization.email.emailIsNotSet" />
                  <RouterLink to="/settings/notifications">
                    <I18n path="detalization.email.toSettings" />
                  </RouterLink>
                </div>
              ) : (
                <div>
                  <RouterLink to="/settings/notifications">
                    <I18n path="detalization.email.mailConfiguration" />
                  </RouterLink>
                </div>
              )}
            </div>

            <Button
              className="big"
              onClick={this.downloadReport}
            >
              <I18n path="detalization.reportPopup.saveDetalization" />
            </Button>
          </>
        )}

        {step === 'loading' && (
          <>
            <Heading className={cx('heading')} level={1}>
              <I18n path="detalization.reportPopup.loadingTitle" />
            </Heading>
            <div className={cx('subtitle')}>
              <I18n path="detalization.reportPopup.loadingMessage" />
            </div>
            <div className={cx('preloader')}>
              <Preloader size="80" />
            </div>
          </>
        )}

        {step === 'success' && (
          <>
            <Heading className={cx('heading')} level={1}>
              <I18n path="detalization.reportPopup.successTitle" />
            </Heading>
            <Button
              className="big"
              onClick={this.closePopup}
            >
              <I18n path="detalization.reportPopup.continue" />
            </Button>
          </>
        )}

        {step === 'error' && (
          <>
            <Heading className={cx('heading')} level={1}>
              <I18n path="detalization.reportPopup.errorTitle" />
            </Heading>
            <Button
              className="big"
              onClick={this.closePopup}
            >
              <I18n path="detalization.reportPopup.continue" />
            </Button>
          </>
        )}
      </Popup>
    );
  }
}

function mapStateToProps(state) {
  return {
    activePopup: state.application.popup,
    period: state.detalization.period,
    isEmailExist: state.detalization.email.isExist,
    emailAddress: state.detalization.email.emailAddress,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      closePopup,
      downloadReport,
      fetchIsEmailExist,
    }, dispatch),
  };
}

ReportPopup.propTypes = {
  period: PropTypes.object,
  actions: PropTypes.object,
  activePopup: PropTypes.string,
  isEmailExist: PropTypes.bool,
  emailAddress: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportPopup);
